var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { convertProcedureToNodeMap } from 'sweet-graphs';
import { procedureProgressToProgressMap } from '../procedure-task/procedure-progress-to-progress-map';
import { extractProcedureTaskProgressInfo } from '../procedure-task/extract-procedure-task-progress-info';
import { getProcedureVersionFromTaskInstance } from '../procedure-task/get-procedure-version-from-taskinstance';
import { TaskState } from './task-state';
import { ProcedureTaskPayload } from './payload/procedure-task-payload';
import { BaseTaskPayload } from './payload/base-payload';
import { mergeProgressIntoTask } from './payload/merge-task-progress';
import { ProcessTaskCoreWithVersion } from './process-task-core';
var BaseProcedureTaskCore = /** @class */ (function () {
    function BaseProcedureTaskCore(task, procedureHashid) {
        this.ct = 'procedure';
        this.progress = null;
        this.task = task;
        this.procedureHashid = procedureHashid;
        this.progress = task.progress[procedureHashid];
    }
    BaseProcedureTaskCore.prototype.isProcedureTask = function () {
        var assignedDoc = this.task.template.assigned_object;
        if (assignedDoc.content_type === 'procedure') {
            if (assignedDoc.hashid === this.procedureHashid) {
                return true;
            }
            throw Error('ProcedureTaskCore initialize with invalid procedureHashid ' +
                this.procedureHashid);
        }
        return false;
    };
    BaseProcedureTaskCore.prototype.getIsCompleted = function () {
        if (this.isProcedureTask()) {
            return this.task.completed != null;
        }
    };
    BaseProcedureTaskCore.prototype.getCompletedBy = function () {
        if (this.isProcedureTask() && this.task.completed_by != null) {
            return this.task.completed_by;
        }
    };
    return BaseProcedureTaskCore;
}());
var ProcedureTaskCoreWithNoVersion = /** @class */ (function (_super) {
    __extends(ProcedureTaskCoreWithNoVersion, _super);
    function ProcedureTaskCoreWithNoVersion(task, procedureHashid) {
        var _this = _super.call(this, task, procedureHashid) || this;
        _this.hasVersion = false;
        /* fallback function for tasks without version */
        _this.calculateProgressUpdated = function (progressPayload) {
            return {
                is_completeable: true,
                progress_percent: null,
            };
        };
        /* payload class */
        _this._payload = null;
        return _this;
    }
    Object.defineProperty(ProcedureTaskCoreWithNoVersion.prototype, "isCompleted", {
        get: function () {
            return _super.prototype.getIsCompleted.call(this);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProcedureTaskCoreWithNoVersion.prototype, "completedBy", {
        get: function () {
            return _super.prototype.getCompletedBy.call(this);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProcedureTaskCoreWithNoVersion.prototype, "titles", {
        get: function () {
            var titles = [];
            if (this.isProcedureTask()) {
                if (this.task.description != null) {
                    titles.push(this.task.description);
                }
                titles.push(this.task.name);
                return titles;
            }
            return ['', ''];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProcedureTaskCoreWithNoVersion.prototype, "payload", {
        get: function () {
            if (this._payload == null)
                this._payload = new BaseTaskPayload(this.calculateProgressUpdated);
            return this._payload;
        },
        enumerable: false,
        configurable: true
    });
    return ProcedureTaskCoreWithNoVersion;
}(BaseProcedureTaskCore));
export { ProcedureTaskCoreWithNoVersion };
var ProcedureTaskCoreWithVersion = /** @class */ (function (_super) {
    __extends(ProcedureTaskCoreWithVersion, _super);
    function ProcedureTaskCoreWithVersion(task, 
    // version can be TaskInstanceProcedureAssignedVersionContent when it's a procedure task
    // then version will be read from task.assigned_version_content
    // version can be ProcessProcedureAsStepInTaskSerializedType when it's a process task
    // version will be read from task.assigned_version_content.content
    version) {
        var _this = _super.call(this, task, version.hashid) || this;
        _this.version = version;
        _this.hasVersion = true;
        /* state */
        _this._state = null;
        /* payload class */
        _this._payload = null;
        /**
         * Merge progress payload into current progress object to calculate
         * `progress_percent` and `is_completeable`, so these fields can be added to update
         * payload
         */
        _this.calculateProgressUpdated = function (progressPayload) {
            if (_this.task.template.assigned_object.content_type === 'proceduregroup') {
                var processTaskCore = new ProcessTaskCoreWithVersion(mergeProgressIntoTask(progressPayload, _this.task), _this.task
                    .assigned_version_content);
                return processTaskCore.calculateProgressUpdated(progressPayload);
            }
            // force recalculation of state
            var originalState = _this._state;
            var originalProgress = _this.progress;
            _this._state = null;
            _this.progress = mergeProgressIntoTask(progressPayload, _this.task).progress[_this.procedureHashid];
            var progress_percent = _this.percentComplete != null ? Math.round(_this.percentComplete) : null;
            var is_completeable = _this.state.progressInfo.canBeCompleted;
            _this._state = originalState;
            _this.progress = originalProgress;
            return { progress_percent: progress_percent, is_completeable: is_completeable };
        };
        return _this;
    }
    Object.defineProperty(ProcedureTaskCoreWithVersion.prototype, "titles", {
        get: function () {
            var titles = [];
            if (this.isProcedureTask() && this.task.description != null) {
                titles.push(this.task.description);
            }
            titles.push(this.version.name);
            return titles;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProcedureTaskCoreWithVersion.prototype, "isCompleted", {
        get: function () {
            var _a;
            var taskIsCompleted = _super.prototype.getIsCompleted.call(this);
            if (taskIsCompleted != null) {
                return taskIsCompleted;
            }
            return ((_a = this.progress) === null || _a === void 0 ? void 0 : _a.completed) != null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProcedureTaskCoreWithVersion.prototype, "completedBy", {
        get: function () {
            var _a;
            var taskCompletedBy = _super.prototype.getCompletedBy.call(this);
            if (taskCompletedBy != null) {
                return taskCompletedBy;
            }
            return (_a = this.progress) === null || _a === void 0 ? void 0 : _a.completed_by;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProcedureTaskCoreWithVersion.prototype, "state", {
        get: function () {
            var _this = this;
            if (this._state == null) {
                var _a = this.version, content_1 = _a.content, steps_blocked_at_1 = _a.steps_blocked_at;
                this._state = new TaskState(steps_blocked_at_1 != null, function () { return convertProcedureToNodeMap(content_1); }, function (nodeMap) {
                    return procedureProgressToProgressMap(_this.progress, nodeMap);
                }, function (nodeMap, progressMap) {
                    return extractProcedureTaskProgressInfo(nodeMap, progressMap, steps_blocked_at_1 != null);
                }, this.task.assigned_version_content != null
                    ? this.task.assigned_version_content.lanes
                    : {}, this.task.assignments);
            }
            return this._state;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProcedureTaskCoreWithVersion.prototype, "percentComplete", {
        get: function () {
            return this.state.progressInfo.percentComplete;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProcedureTaskCoreWithVersion.prototype, "payload", {
        get: function () {
            if (this._payload == null)
                this._payload = new ProcedureTaskPayload(this.task.template.assigned_object.content_type, this.procedureHashid, this.state.nodeMap, this.state.orderedIds, this.calculateProgressUpdated);
            return this._payload;
        },
        enumerable: false,
        configurable: true
    });
    return ProcedureTaskCoreWithVersion;
}(BaseProcedureTaskCore));
export { ProcedureTaskCoreWithVersion };
export function getProcedureTaskCore(task, procedureHashid) {
    if (procedureHashid == null) {
        if (task.template.assigned_object.content_type !== 'procedure') {
            throw Error("Cannot identify procedure hashid of task ".concat(task));
        }
        procedureHashid = task.template.assigned_object.hashid;
    }
    var version = getProcedureVersionFromTaskInstance(task, procedureHashid);
    return version != null
        ? new ProcedureTaskCoreWithVersion(task, version)
        : new ProcedureTaskCoreWithNoVersion(task, procedureHashid);
}
